import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    
    if (request.url.startsWith('/api/') || request.url.includes('ciadofrete.com.br')) {
      const clonedRequest = request.clone({
        withCredentials: true
      });
      return next.handle(clonedRequest);
    }

    return next.handle(request);
  }
}
